//libs\components\mascot\src\lib\mascot.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiMascotComponent } from './ui-mascot/ui-mascot.component';

@NgModule({
  imports: [CommonModule],
  declarations: [UiMascotComponent],
  exports: [UiMascotComponent],
})
export class MascotModule {}
